var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.loadPage)?_c('div',{staticClass:"main-panel"},[_c('dashboard-content')],1):_vm._e(),_c('loader',{attrs:{"loadingStatus":_vm.loaderStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }